import { generateCustomPath } from "helpers/common";
import { baseApi } from "utils/axios/baseApi"
import { APPOINTMENT_ASSIGN_CHATTER, APPOINTMENT_ASSIGN_THERAPIST, APPOINTMENT_UNASSIGN_CHATTER, ASSIGN_THERAPIST, CLIENT_APPT_BALANCE_ADD, CLIENT_APPT_BALANCE_LIST, CLIENT_APPT_BALANCE_UPDATE, CREATE_APPOINTMENT, DELETE_APPOINTMENT, GET_APPOINMENT_CONSENT_FORMS, GET_APPOINTMENT_ASSESSMENT_LIST, GET_APPOINTMENT_ASSIGN_CHATTER_LIST, GET_APPOINTMENT_ASSIGN_THERAPISTS_LIST, GET_APPOINTMENT_CLIENTS_LIST, GET_APPOINTMENT_CONSENT_FORMS, GET_APPOINTMENT_DETAILS, GET_APPOINTMENT_PARENTS_LIST, GET_APPOINTMENT_THERAPISTS, GET_APPOINTMENTS_LIST, MANAGE_ASSESSMENT_SERVICES_CREATE, MANAGE_ASSESSMENT_SERVICES_DELETE, MANAGE_ASSESSMENT_SERVICES_LIST, MANAGE_ASSESSMENT_SERVICES_UPDATE, MANAGE_ASSESSMENT_SERVICES_VIEW, SEND_APPOINTMENT_MAIL, UNASSIGN_ALL_APPOINTMENT_THERAPISTS, UNASSIGN_APPOINTMENT_THERAPIST, UPDATE_APPOINTMENT } from "config/apiPaths";

const assessmentServicesManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getAssessmentServicesList: builder.query({
      query: ({ page, limit, search, status }) => ({
        method: "PATCH",
        url: MANAGE_ASSESSMENT_SERVICES_LIST,
        data: {
          page,
          limit,
          search,
          status
        }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assessmentServicesList']
    }),

    createAssessmentServices: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: `${MANAGE_ASSESSMENT_SERVICES_CREATE}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentServicesList']
    }),

    deleteAssessmentServices: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${MANAGE_ASSESSMENT_SERVICES_DELETE}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentServicesList']
    }),

    getAssessmentServiceView: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${MANAGE_ASSESSMENT_SERVICES_VIEW}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assessmentServiceView']
    }),


    updateAssessmentServices: builder.mutation({
      query: ({ body, id }) => ({
        method: "PUT",
        url: `${MANAGE_ASSESSMENT_SERVICES_UPDATE}/${id}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentServicesList', 'assessmentServiceView','appointmentAssessmentList']
    }),
    // save balance
    // createAppointment: builder.mutation({
    //   query: ({ body }) => ({
    //     method: "POST",
    //     url: CREATE_APPOINTMENT,
    //     data: body
    //   }),
    //   transformResponse: (response) => {
    //     return response.data;
    //   },
    //   invalidatesTags: ['appointmentList']
    // }),

  })
})

export const {
  useGetAssessmentServicesListQuery,
  useCreateAssessmentServicesMutation,
  useDeleteAssessmentServicesMutation,
  useGetAssessmentServiceViewQuery,
  useUpdateAssessmentServicesMutation
} = assessmentServicesManagementApi